import { MultiSelectTheme } from "chakra-multiselect";

export const MultiSelect: typeof MultiSelectTheme = {
  ...MultiSelectTheme,
  baseStyle: (props) => {
    const style = MultiSelectTheme.baseStyle(props);
    style.control = {
      ...style.control,
      // @ts-expect-error
      borderRadius: "md",
    };
    style.list = {
      ...style.list,
      // @ts-expect-error
      borderColor: "gray.700",
    };
    console.log(style);
    return style;
  },
};
